<template>
  <div
    class="pa-3"
    style="height: 340px">
    <v-text-field
      filled
      style="height: 66px"
      label="Name"
      v-model="data.name"
      v-on:keyup.enter="$emit('create')"></v-text-field>
    <v-checkbox
      v-model="data.live"
      label="External Source"
      hide-details></v-checkbox>

    <!-- json editor -->
    <div v-show="!data.live">
      <div style="width: 100%">
        <JSONEditor :item="{ value: data.json_text }" />
      </div>
    </div>

    <v-text-field
      v-if="data.live"
      filled
      style="height: 66px"
      label="JSON URL"
      v-model="data.url"
      v-on:keyup.enter="$emit('create')"></v-text-field>
    <v-text-field
      v-if="data.live"
      filled
      style="height: 66px"
      label="Update Interval"
      v-model="data.interval"
      v-on:keyup.enter="$emit('create')"></v-text-field>
  </div>
</template>

<script setup>
import { reactive, watch, ref, onMounted } from 'vue';
import JSONEditor from '../../Shared/SceneDataSubItems/JSONEditor.vue';

const props = defineProps({
  userEditObj: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['update:data', 'create']);
const editorRef = ref(null);
let editor = null;

const data = reactive({
  name: '',
  json_text: {},
  live: false,
  url: '',
  interval: 60,
});

onMounted(() => {
  if (editorRef.value) {
    editor = new JSONEditor({
      target: editorRef.value,
      props: {
        content: { json: data.json_text },
        mode: 'text',
        onChange: (updatedContent) => {
          if (updatedContent.text !== undefined) {
            data.json_text = updatedContent.text;
          } else if (updatedContent.json !== undefined) {
            data.json_text = JSON.stringify(updatedContent.json);
          }
        },
      },
    });
  }
});

// Watch for changes in the data and emit them
watch(
  data,
  () => {
    emit('update:data', JSON.parse(JSON.stringify(data)));
  },
  { deep: true, immediate: true }
);
</script>
